import {useEffect, useState} from "react";
import {getMainWidth , handelTitle} from '../../utils'
import {data1 , data2 , data3} from '../../data/data-containers/data-Home.js';
import {HomeIcon1 , HomeIcon2 , HomeIcon3} from '../../utils/allImgs'
import viri from '../../assets/img/viri.png'

// import {Fluid1 , Fluid2} from './Fluid';
import MainHeader from './MainHeader'
import SectionCard from './SectionCard'

import SectionHeading from '../../components/SectionHeading'
import SecNewListed from '../../components/SecNewListed'
import SecLiveAuctions from '../../components/SecLiveAuctions'
import AuctionListHeading from "../../components/AuctionListHeading";


/**
 * Home page container (Active Listings).
 *
 * Main landing page showing active NFT auctions and listings.
 * Features:
 * - Main header with marketplace branding
 * - Auction list heading with view mode selector
 * - Live auctions display (SecLiveAuctions)
 *
 * Allows users to browse and interact with current marketplace activity.
 *
 * @module containers/Listings
 * @category Containers
 * @param {Object} props
 * @param {Array} props.initialAuctions - Optional preloaded auction data from route loader
 * @returns {React.ReactElement} Rendered home page
 */
const HomeContainer = ({ initialAuctions }) => {

  const [auctionsView, sav] = useState('Ending Soonest');

  useEffect(() => {
    handelTitle('Dashboard')
    getMainWidth()
  },[])

  useEffect(()=> {

  }, [auctionsView])

  return (
    <>
      <main className="main-content mt-1 border-radius-lg text-green">
        <MainHeader />

        <div style={{maxWidth: 1400, margin: "0 auto"}}>
          <AuctionListHeading
              img={viri}
              text={auctionsView}
              title='Active Listings'
              sav={sav}
          />

          <SecLiveAuctions
            lType={auctionsView}
            initialAuctions={initialAuctions}
          />
        </div>

      </main>
    </>
  );
}

export default HomeContainer;

